import { gql } from "@apollo/client"

export const GENERATE_CAMPAIGN_DESCRIPTION = gql`
  mutation GenerateCampaignDescription(
    $goal: String!
    $story: String!
    $amountUsage: String!
    $beneficiary: String!
    $trustElements: String
    $tone: String
    $campaignCategory: String
    $language: String
  ) {
    generateCampaignDescription(
      goal: $goal
      story: $story
      amountUsage: $amountUsage
      beneficiary: $beneficiary
      trustElements: $trustElements
      tone: $tone
      campaignCategory: $campaignCategory
      language: $language
    ) {
      title
      content
    }
  }
`

export const TRANSLATE_CAMPAIGN_DESCRIPTION = gql`
  mutation TranslateCampaignDescription(
    $content: String!
    $sourceLanguage: String
  ) {
    translateCampaignDescription(
      content: $content
      sourceLanguage: $sourceLanguage
    ) {
      translations
    }
  }
`
